/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as PermissionService} from "../../../Services/PermissionService";
import React from "react";

export class UserPermissionFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			permission: null
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		PermissionService.GetPermission(this.props.Value)
			.then((x) => {
				this.setState({permission: x.result});
			});
	}

	@autobind
	_render() {
		return <div className="sb-user-permission-field">
			<span>{this.state.permission?.name}</span>
			<span style={{paddingLeft: '20px'}}>{this.props.Data?.value ? 'Yes' : 'No'}</span>
		</div>;
	}
}